import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface CampMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface CampMst {
   id?: any;
   campName? :string;
   campType?:number;
   campDescription?:string;
   campOrganizer:string;
   campDisplayValue?:string;
   campLocation?:string;
   status?:string;
   statusFlag?:string;
   statusReason?:string;
   activeFlag?:string;
    participantsDetail?:string;
    transportDetail?:string;
    plannedStartDate?:Date;
    plannedEndDate?:Date;
    actualStartDate?:Date;
    actualEndDate?:Date;
   medicineDetail?:string;
     city?:string;
       pincode?:string;
         state?:any;
    district?:any;
    country?:any;
     guestDetail?:string;
    address1?:string;
    address2?:string;
    createdDate?:Date;
     updatedDate?:Date;
     createdBy?:number;
    updatedBy?: number;
    createdIP?:string;
    updatedIP?:string;
    tenantId:any;
    branchId:any;
    parameters?: CampMstParameter[];
    links?: any;
}

export interface CampFileEntryDto { 
   employeeId:number;
   fileName:string;
   entryDate:Date;
   campType:string;
   campFile: CampFileDto[];
}

export interface CampFileDto { 
   firstName:string;
   lastName?:string;
   dob?:any;
   age?:number;
   gender?:string;
   martialStatus:string;
   city?:string;
   district?:String;
   state?:string;
   country?:string;
   pincode?:string;
   address1?:string;
  address2?:string; 
  mobile?:string;
  landline?:string;
  aaadhar?:string;
  doorNo?:string;
  bloodGroup?:string;
  email?:string;
}

export abstract class CampData {
    abstract list(url: string): Observable<CampMst[]>;
    abstract create(url: string, data: any): Observable<any[]>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract update(url: string, data: CampMst): Observable<CampMst>;
    abstract delete(url: string): Observable<any>;
}

